/* cerasonar V53 · Original product and variant names are deliberately language-independent.
 * SKU snapshots come from the selected shop variants (6 October 2026).
 * frame 6280 SKU 1299 was confirmed by cerasonar in this project.
 * Live variant metadata replaces snapshots. Empty SKU values are never invented.
 * Area targets and SPL allowances are preliminary planning assumptions, not measured room ratings.
 */
(function(host,factory){'use strict';const api=factory();if(typeof module==='object'&&module.exports)module.exports=api;else host.CerasonarBuilderCatalog=api;})(typeof globalThis!=='undefined'?globalThis:this,function(){'use strict';
 const data = {
  "products": {
    "ref4062": {
      "id": 40953569869992,
      "name": "cerasonar 4062 reference",
      "kind": "speaker",
      "key": "ref4062",
      "frame": "frame4062",
      "wood": false,
      "sku": "1261",
      "handle": "4062-reference",
      "metadataVerified": true,
      "spl": 105,
      "rms": 50,
      "referencePower": 100,
      "ohms": 4,
      "bodyDepth": 58,
      "singleStereo": true
    },
    "protectionPro25": {
      "id": 41451597529256,
      "name": "cerasonar protection unit pro - protection unit pro 25 W",
      "kind": "kit",
      "key": "protectionPro25",
      "sku": "1200",
      "handle": "protection-unit-pro",
      "metadataVerified": true
    },
    "fit1520": {
      "id": 53405713826059,
      "name": "cerasonar 1520 fit - 8 Ω – standard",
      "kind": "speaker",
      "frame": "frame1520",
      "wood": false,
      "key": "fit1520",
      "sku": "1270",
      "handle": "1520-fit",
      "metadataVerified": true,
      "spl": 97,
      "rms": 25,
      "referencePower": 50,
      "impedance": 8,
      "bodyDepth": 53.5
    },
    "fit1520system": {
      "id": 53405713858827,
      "name": "cerasonar 1520 fit - 12 Ω – system version",
      "kind": "speaker",
      "frame": "frame1520",
      "wood": false,
      "key": "fit1520system",
      "sku": "1270-2",
      "handle": "1520-fit",
      "metadataVerified": true,
      "spl": 97,
      "rms": 25,
      "referencePower": 50,
      "impedance": 12,
      "bodyDepth": 53.5
    },
    "fit2525": {
      "id": 41005273350312,
      "name": "cerasonar 2525 fit",
      "kind": "speaker",
      "frame": "frame2525",
      "wood": false,
      "key": "fit2525",
      "sku": "1271",
      "handle": "2525-fit",
      "metadataVerified": true,
      "spl": 100,
      "rms": 50,
      "referencePower": 100,
      "impedance": 4,
      "bodyDepth": 53.5,
      "singleStereo": true
    },
    "fit1520_100v": {
      "id": 44990617583883,
      "name": "cerasonar 1520 fit – 100 V",
      "kind": "speaker",
      "frame": "frame1520",
      "wood": false,
      "key": "fit1520_100v",
      "sku": "1270-1",
      "handle": "1520-fit-100v",
      "metadataVerified": true,
      "spl": 96,
      "rms": 20,
      "referencePower": 20,
      "impedance": 0,
      "bodyDepth": 53
    },
    "ref4062pro": {
      "id": 41006064795816,
      "name": "cerasonar 4062 reference pro",
      "kind": "speaker",
      "frame": "frame4062",
      "wood": true,
      "key": "ref4062pro",
      "sku": "1261-1",
      "handle": "4062-reference-pro",
      "metadataVerified": true,
      "spl": 107,
      "rms": 75,
      "referencePower": 150,
      "impedance": 4,
      "bodyDepth": 58
    },
    "ultimate4080": {
      "id": 44089095422219,
      "name": "cerasonar 4080 ultimate",
      "kind": "speaker",
      "frame": "frame4080",
      "wood": false,
      "key": "ultimate4080",
      "sku": "1281-1",
      "handle": "4080-ultimate",
      "metadataVerified": true,
      "spl": 103,
      "rms": 75,
      "referencePower": 150,
      "impedance": 4,
      "bodyDepth": 93
    },
    "ref6280pro": {
      "id": 46614272835851,
      "name": "cerasonar 6280 reference pro",
      "kind": "speaker",
      "frame": "frame6280",
      "wood": true,
      "key": "ref6280pro",
      "sku": "1263-1",
      "handle": "6280-reference-pro",
      "metadataVerified": true,
      "spl": 110,
      "rms": 150,
      "referencePower": 300,
      "impedance": 8,
      "bodyDepth": 58,
      "singleStereo": true
    },
    "sub4080": {
      "id": 45919933137163,
      "name": "cerasonar 4080 sub",
      "kind": "sub",
      "frame": "frame4080",
      "wood": false,
      "metal": true,
      "key": "sub4080",
      "sku": "1256",
      "handle": "4080-sub",
      "metadataVerified": true,
      "spl": 103,
      "rms": 150,
      "referencePower": 300,
      "impedance": 4,
      "bodyDepth": 93
    },
    "subArchitect": {
      "id": 43595427873035,
      "name": "cerasonar architect sub",
      "kind": "sub",
      "frame": null,
      "wood": true,
      "metal": true,
      "key": "subArchitect",
      "sku": "1276",
      "handle": "architect-sub",
      "metadataVerified": true,
      "spl": 108,
      "rms": 150,
      "referencePower": 300,
      "impedance": 4,
      "bodyDepth": 200
    },
    "sub6280": {
      "id": 45920040747275,
      "name": "cerasonar 6280 sub",
      "kind": "sub",
      "frame": "frame6280",
      "wood": false,
      "metal": false,
      "key": "sub6280",
      "sku": "1266",
      "handle": "6280-sub",
      "metadataVerified": true,
      "spl": 105,
      "rms": 250,
      "referencePower": 500,
      "impedance": 4,
      "bodyDepth": 112
    },
    "sub62200": {
      "id": 52939555373323,
      "name": "cerasonar 62200 sub",
      "kind": "sub",
      "frame": null,
      "wood": false,
      "metal": false,
      "key": "sub62200",
      "sku": "1267",
      "handle": "cerasonar-62200-sub",
      "metadataVerified": true,
      "spl": 122,
      "rms": 1000,
      "referencePower": 2000,
      "impedance": 4,
      "bodyDepth": 192
    },
    "amp150": {
      "id": 52970348314891,
      "name": "cerasonar cs-150smart2",
      "kind": "amp",
      "key": "amp150",
      "sku": "1209",
      "handle": "cs-150smart2",
      "metadataVerified": true
    },
    "amp500": {
      "id": 53207225434379,
      "name": "cerasonar cs-500dsp4 v2",
      "kind": "amp",
      "key": "amp500",
      "sku": "1206",
      "handle": "cs-500dsp4",
      "metadataVerified": true
    },
    "amp2000": {
      "id": 42160512499880,
      "name": "cerasonar cs-2000dsp4",
      "kind": "amp",
      "key": "amp2000",
      "sku": "1202",
      "handle": "cs-2000dsp4",
      "metadataVerified": true
    },
    "cable": {
      "id": 44974649147659,
      "kind": "cable",
      "key": "cable",
      "sku": "",
      "handle": "installation-cable",
      "name": "cerasonar installation cable - 2x2.08 mm² / Per metre",
      "metadataVerified": true
    },
    "protection25": {
      "id": 41451593826472,
      "name": "cerasonar protection unit - protection unit 25w",
      "kind": "kit",
      "key": "protection25",
      "sku": "1203",
      "handle": "protection-unit",
      "metadataVerified": true
    },
    "protection50": {
      "id": 41451593859240,
      "name": "cerasonar protection unit - protection unit 50w",
      "kind": "kit",
      "key": "protection50",
      "sku": "1204",
      "handle": "protection-unit",
      "metadataVerified": true
    },
    "protectionPro": {
      "id": 42130637389992,
      "name": "cerasonar protection unit pro - protection unit pro 50/100 W",
      "kind": "kit",
      "key": "protectionPro",
      "sku": "1200-1",
      "handle": "protection-unit-pro",
      "metadataVerified": true
    },
    "masonry": {
      "id": 45889835172107,
      "kind": "kit",
      "key": "masonry",
      "sku": "1340",
      "handle": "masonry-installation-kit",
      "name": "cerasonar masonry installation kit",
      "metadataVerified": true
    },
    "antiVibration": {
      "id": 45889869316363,
      "kind": "kit",
      "key": "antiVibration",
      "sku": "1341",
      "handle": "drywall-ceiling-anti-vibration-kit",
      "name": "cerasonar drywall ceiling anti-vibration kit",
      "metadataVerified": true
    },
    "ceiling4062": {
      "id": 45889660223755,
      "size": "4062 / 1520 / 2525",
      "kind": "kit",
      "key": "ceiling4062",
      "sku": "1335",
      "handle": "drywall-ceiling-kit",
      "name": "cerasonar drywall ceiling kit - frame 4062 (1520&2525 as well!)",
      "metadataVerified": true
    },
    "ceiling4080": {
      "id": 45889660256523,
      "size": "4080",
      "kind": "kit",
      "key": "ceiling4080",
      "sku": "1334",
      "handle": "drywall-ceiling-kit",
      "name": "cerasonar drywall ceiling kit - frame 4080",
      "metadataVerified": true
    },
    "ceiling6280": {
      "id": 45889660322059,
      "size": "6280",
      "kind": "kit",
      "key": "ceiling6280",
      "sku": "1337",
      "handle": "drywall-ceiling-kit",
      "name": "cerasonar drywall ceiling kit - frame 6280",
      "metadataVerified": true
    },
    "pocket4062": {
      "id": 45124794646795,
      "size": "4062 / 19 mm",
      "kind": "kit",
      "key": "pocket4062",
      "sku": "1333",
      "handle": "cerasonar-panel-pocket-mount-kit",
      "name": "cerasonar panel pocket mount kit - 4062 / 19 mm (standard)",
      "metadataVerified": true
    },
    "pocket6280": {
      "id": 53151535890699,
      "size": "6280 / 19 mm",
      "kind": "kit",
      "key": "pocket6280",
      "sku": "1327",
      "handle": "cerasonar-panel-pocket-mount-kit",
      "name": "cerasonar panel pocket mount kit - 6280 / 19 mm (standard)",
      "metadataVerified": true
    },
    "tape4062": {
      "id": 53151555584267,
      "size": "4062",
      "kind": "kit",
      "key": "tape4062",
      "sku": "1332",
      "handle": "pocket-mount-double-sided-tape",
      "name": "cerasonar pocket mount double-sided tape - 4062",
      "metadataVerified": true
    },
    "tape6280": {
      "id": 53151555649803,
      "size": "6280",
      "kind": "kit",
      "key": "tape6280",
      "sku": "1324",
      "handle": "pocket-mount-double-sided-tape",
      "name": "cerasonar pocket mount double-sided tape - 6280",
      "metadataVerified": true
    },
    "frame1520": {
      "id": 45727632392459,
      "size": "1520",
      "kind": "kit",
      "key": "frame1520",
      "sku": "1291-1",
      "handle": "installation-frame-backbox",
      "name": "cerasonar installation frames (backboxes) - frame 1520",
      "metadataVerified": true,
      "bodyDepth": 120,
      "openingDepth": 140
    },
    "frame2525": {
      "id": 45727632425227,
      "size": "2525",
      "kind": "kit",
      "key": "frame2525",
      "sku": "1291-2",
      "handle": "installation-frame-backbox",
      "name": "cerasonar installation frames (backboxes) - frame 2525",
      "metadataVerified": true,
      "bodyDepth": 120,
      "openingDepth": 140
    },
    "frame4062": {
      "id": 45727632457995,
      "size": "4062",
      "kind": "kit",
      "key": "frame4062",
      "sku": "1291",
      "handle": "installation-frame-backbox",
      "name": "cerasonar installation frames (backboxes) - frame 4062",
      "metadataVerified": true,
      "bodyDepth": 120,
      "openingDepth": 140
    },
    "frame4080": {
      "id": 45727632589067,
      "size": "4080",
      "kind": "kit",
      "key": "frame4080",
      "sku": "1297",
      "handle": "installation-frame-backbox",
      "name": "cerasonar installation frames (backboxes) - frame 4080",
      "metadataVerified": true,
      "bodyDepth": 120,
      "openingDepth": 140
    },
    "frame6280": {
      "id": 46613847015691,
      "size": "6280",
      "kind": "kit",
      "key": "frame6280",
      "sku": "1299",
      "handle": "installation-frame-backbox",
      "name": "cerasonar installation frames (backboxes) - frame 6280",
      "metadataVerified": true
    },
    "frame62200": {
      "id": null,
      "size": "62200",
      "kind": "project",
      "key": "frame62200",
      "sku": "",
      "handle": "",
      "metadataVerified": false,
      "nameKey": "projectMount"
    },
    "projectMount": {
      "id": null,
      "nameKey": "projectMount",
      "kind": "project",
      "key": "projectMount"
    },
    "projectSource": {
      "id": null,
      "nameKey": "projectSource",
      "kind": "project",
      "key": "projectSource"
    },
    "projectProcessor": {
      "id": null,
      "nameKey": "projectProcessor",
      "kind": "project",
      "key": "projectProcessor"
    },
    "projectAnchors": {
      "key": "projectAnchors",
      "id": null,
      "nameKey": "projectAnchors",
      "kind": "project"
    },
    "projectReceiver": {
      "key": "projectReceiver",
      "id": null,
      "nameKey": "projectReceiver",
      "kind": "project"
    }
  },
  "packages": {
    "smartS": {
      "name": "SMART COVERAGE S",
      "speakerQty": 4,
      "subQty": 0,
      "ampQty": 1,
      "preset": "1270-2 / S / mono / 2+2"
    },
    "smartSplus": {
      "name": "SMART COVERAGE S+",
      "speakerQty": 4,
      "subQty": 1,
      "ampQty": 1,
      "preset": "1270-2 + 1256 / S+ / mono / 4+1"
    },
    "smartM": {
      "name": "SMART COVERAGE M",
      "speakerQty": 8,
      "subQty": 0,
      "ampQty": 1,
      "preset": "1270-2 / M / mono / 4+4"
    },
    "smartMplus": {
      "name": "SMART COVERAGE M+",
      "speakerQty": 8,
      "subQty": 2,
      "ampQty": 2,
      "preset": "1270-2 + 1256 / M+ / 2 × S+ / mono / 4+1"
    }
  },
  "planning": {
    "coverageSpeakers": {
      "background": "fit1520system",
      "everyday": "ref4062",
      "high": "ref4062pro",
      "highLarge": "ref6280pro",
      "highLargeArea": 35
    },
    "speakerArea": {
      "background": 17.5,
      "everyday": 12.5,
      "high": 8.5
    },
    "subArea": {
      "sub4080": {
        "balanced": 15,
        "powerful": 10
      },
      "subArchitect": {
        "balanced": 40,
        "powerful": 30
      },
      "sub6280": {
        "balanced": 40,
        "powerful": 30
      },
      "sub62200": {
        "balanced": 100,
        "powerful": 80
      }
    },
    "levelFactor": {
      "background": 1.15,
      "everyday": 1,
      "high": 0.8
    },
    "maxArea": 250,
    "maxSpeakers": 20,
    "maxSubs": 20,
    "spl": {
      "listenerHeight": 1.2,
      "overlapLimit": 3,
      "fullRangeAllowance": 6,
      "thresholds": [
        80,
        90,
        100
      ],
      "referenceDistance": 1
    }
  },
  "sets": {
    "stereoS": {
      "name": "STEREO S",
      "family": "stereo",
      "speaker": "ref4062",
      "speakerQty": 2,
      "heightSpeaker": "ref4062",
      "heightSpeakerQty": 0,
      "subChoice": "none",
      "subQty": 0,
      "system": "easy",
      "amps": {
        "amp150": 1
      },
      "frames": {
        "frame4062": 2
      }
    },
    "stereoM": {
      "name": "STEREO M",
      "family": "stereo",
      "speaker": "ultimate4080",
      "speakerQty": 2,
      "heightSpeaker": "ultimate4080",
      "heightSpeakerQty": 0,
      "subChoice": "none",
      "subQty": 0,
      "system": "easy",
      "amps": {
        "amp150": 1
      },
      "frames": {
        "frame4080": 2
      }
    },
    "stereoL": {
      "name": "STEREO L",
      "family": "stereo",
      "speaker": "ref4062pro",
      "speakerQty": 2,
      "heightSpeaker": "ref4062pro",
      "heightSpeakerQty": 0,
      "subChoice": "subArchitect",
      "subQty": 2,
      "system": "premium",
      "amps": {
        "amp500": 1
      },
      "frames": {
        "frame4062": 2
      }
    },
    "stereoXL": {
      "name": "STEREO XL",
      "family": "stereo",
      "speaker": "ref6280pro",
      "speakerQty": 2,
      "heightSpeaker": "ref6280pro",
      "heightSpeakerQty": 0,
      "subChoice": "sub6280",
      "subQty": 2,
      "system": "premium",
      "amps": {
        "amp2000": 1
      },
      "frames": {
        "frame6280": 4
      }
    },
    "cinemaS": {
      "name": "HOME CINEMA S",
      "family": "cinema",
      "speaker": "ultimate4080",
      "speakerQty": 5,
      "heightSpeaker": "ultimate4080",
      "heightSpeakerQty": 0,
      "subChoice": "none",
      "subQty": 0,
      "system": "receiver",
      "amps": {},
      "frames": {
        "frame4080": 5
      },
      "layout": "5.1"
    },
    "cinemaM": {
      "name": "HOME CINEMA M",
      "family": "cinema",
      "speaker": "ref4062pro",
      "speakerQty": 5,
      "heightSpeaker": "ref4062pro",
      "heightSpeakerQty": 0,
      "subChoice": "subArchitect",
      "subQty": 2,
      "system": "premium",
      "amps": {
        "amp500": 2
      },
      "frames": {
        "frame4062": 5
      },
      "layout": "5.1"
    },
    "cinemaL": {
      "name": "HOME CINEMA L",
      "family": "cinema",
      "speaker": "ref6280pro",
      "speakerQty": 5,
      "heightSpeaker": "ref4062",
      "heightSpeakerQty": 4,
      "subChoice": "sub6280",
      "subQty": 2,
      "system": "premium",
      "amps": {
        "amp2000": 3
      },
      "frames": {
        "frame6280": 7,
        "frame4062": 4
      },
      "layout": "5.1.4"
    }
  }
};
 Object.values(data.products).forEach(Object.freeze);Object.values(data.packages).forEach(Object.freeze);Object.values(data.sets).forEach(Object.freeze);
 return Object.freeze(data);
});
